module.exports = __webpack_public_path__ + "static/media/religare@3x.7b125e34.png";